import { InputHandler } from '../input-handler';
import { Tool } from './tool';

export class WmsTool extends Tool {
  constructor(inputHandler: InputHandler) {
    super('wms', inputHandler);
    this.visible = false;
  }

  enable() {
    this.visible = true;
    this.inputHandler.setCursor('default');
  }
}
